import React from 'react';
import {
  CREDENTIALS,
} from 'components/brikks/home/AccessManagement2N/components/AccessManagement2NModal/components/AccessLogs/constants';
import { CheckWithBackground } from 'assets/icons/CheckWithBackground';
import { MinusWithBackground } from 'assets/icons/MinusWithBackground';
import { format } from 'date-fns';

const getCredentialsDetail = (credentials) => Object.keys(credentials).find(key => credentials[key] === 'valid');
export const mapDataToClient = (data) => {
  if (!data) return [];

  return data.map((item) => (
    ({
      category: item.Category === 'Granted' ? <CheckWithBackground /> : <MinusWithBackground />,
      time: format(new Date(item.Time), 'MM-dd-yyyy, hh:mm:ss:a'),
      userId: item.Person.Id,
      user: item.Person.Name,
      email: item.Person.Email,
      phoneNumber: item.Person.PhoneNumber,
      accessPoint: item.AccessPoint,
      direction: item.Direction,
      ipAddress: item.Device.Host,
      serialNumber: item.Person.SerialNumber,
      deviceTime: item.DeviceTime,
      deviceSerialNumber: item.Device.SerialNumber,
      companyId: item.Person.Company.Id,
      company: item.Person.Company.Name,
      isVisitor: item.IsVisitor,
      deviceId: item.Device.Id,
      deviceName: item.Device.Name,
      deviceCategory: item.Device.Category,
      credentials: {
        type: item.Credentials,
        image: CREDENTIALS[getCredentialsDetail(item.Credentials)],
        value: item.Credentials.Credentials,
      },
      zone: item.ZoneEntered.Name,
      zoneId: item.ZoneEntered.Id,
      detail: item.Detail,
    })
  ));

};
